import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import CareerHero from "../Hero/CareerHero";
import JobList from "../List/JobList";
import JobDetails from "../Details/JobDetails";
import "../Container/CareersContainer.css";
import html2pdf from 'html2pdf.js';
import { Link } from 'react-router-dom';
import { apiConfig } from '../../../lib/apiConfig';

const WHY_CARDS = [
  {
    icon: "🌍",
    title: "Remote-friendly",
    desc: "Travaillez depuis chez vous ou dans nos locaux a Abidjan. On s'adapte a votre rythme.",
  },
  {
    icon: "🚀",
    title: "Projets concrets",
    desc: "Vos realisations atterrissent chez de vraies PME ivoiriennes. Pas de side-project fictif.",
  },
  {
    icon: "🤝",
    title: "Equipe jeune",
    desc: "Ambiance bienveillante, feedback direct, montee en competences garantie.",
  },
];

export default function CareersContainer() {
  const [jobs, setJobs] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeJobId, setActiveJobId] = useState(null);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await fetch(`${apiConfig.publicationBase}/publications?published=true&category=Carriere`);
        const data = await res.json();
        const list = (data && data.success && Array.isArray(data.data)) ? data.data : [];
        const mapped = list.map(p => ({
          id: p.id,
          title: p.title,
          description: (p.body || ''),
          endDate: p.endDate,
          category: p.category,
          publishedAt: p.publishedAt,
          location: p.location,
          contractType: p.contractType,
          attachments: p.attachments || []
        }));
        setJobs(mapped);
        setFiltered(mapped);
        setActiveJobId(mapped[0]?.id || null);
      } catch (_e) {}
      setLoading(false);
    })();
  }, []);

  const activeJob = jobs.find(j => j.id === activeJobId);

  return (
    <div className="careers-page">
      <Helmet>
        <title>Carrieres — NEXUS SOLUTIONS</title>
        <meta name="description" content="Rejoignez l'equipe NEXUS SOLUTIONS a Abidjan. Postes ouverts en developpement web, mobile et e-commerce. CDI, remote-friendly, projets concrets." />
      </Helmet>

      <CareerHero />

      {/* Pourquoi nous rejoindre */}
      <section className="why-join">
        <div className="why-join__inner">
          <h2 className="why-join__title">Pourquoi nous rejoindre ?</h2>
          <div className="why-join__grid">
            {WHY_CARDS.map(c => (
              <div className="why-join__card" key={c.title}>
                <span className="why-join__icon">{c.icon}</span>
                <h3 className="why-join__card-title">{c.title}</h3>
                <p className="why-join__card-desc">{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Job listings */}
      <main id="offres">
        <div className="careers-wrap">
          {loading && <p className="careers-loading">Chargement des offres...</p>}

          {!loading && filtered.length === 0 && (
            <div className="careers-empty">
              <span className="careers-empty__icon">📭</span>
              <h3 className="careers-empty__title">Aucune offre pour l'instant</h3>
              <p className="careers-empty__text">
                On recrute bientot ! Envoyez-nous votre candidature spontanee.
              </p>
              <a
                href="mailto:contact@nxs-solutions.com"
                className="careers-empty__btn"
              >
                Envoyer une candidature spontanee
              </a>
            </div>
          )}

          {!loading && filtered.length > 0 && (
            <div className="careers-main">
              <div className="jobs-list">
                <JobList
                  jobs={filtered}
                  activeJobId={activeJobId}
                  onSelectJob={setActiveJobId}
                />
              </div>
              <div className="job-details-area">
                <JobDetails job={activeJob} />
                <div className="job-cta-panel">
                  <button
                    className="btn-secondary"
                    onClick={() => {
                      const container = document.createElement('div');
                      const style = [
                        ...Array.from(document.querySelectorAll('link[rel="stylesheet"]')).map(link => `<link rel="stylesheet" href="${link.href}" />`),
                        `<style>${[...document.querySelectorAll('style')].map(s => s.innerHTML).join('\n')}</style>`
                      ].join('\n');
                      container.innerHTML = `
                        ${style}
                        <div style='padding:24px;font-family:Arial,sans-serif;'>
                          <h2 style='font-size:1.5rem;margin-bottom:12px;'>${activeJob?.title || ''}</h2>
                          ${activeJob?.description || ''}
                        </div>
                      `;
                      html2pdf().set({
                        margin: 10,
                        filename: `${(activeJob?.title || 'offre').replace(/\s+/g, '_')}.pdf`,
                        image: { type: 'jpeg', quality: 0.98 },
                        html2canvas: { scale: 2 },
                        jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' }
                      }).from(container).save();
                    }}
                  >
                    Telecharger PDF
                  </button>
                  <Link to="/apply" state={{ job: activeJob }} className="btn-primary" role="button">
                    Postuler
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>

      {/* Candidature spontanée permanente */}
      <section className="spontaneous-cta">
        <div className="spontaneous-cta__inner">
          <h2 className="spontaneous-cta__title">Vous ne trouvez pas votre poste ?</h2>
          <p className="spontaneous-cta__text">
            Envoyez-nous votre profil. On garde votre dossier et on vous contacte en priorite lors de nos prochaines ouvertures.
          </p>
          <a
            href="mailto:contact@nxs-solutions.com"
            className="spontaneous-cta__btn"
          >
            Envoyer une candidature spontanee
          </a>
        </div>
      </section>
    </div>
  );
}
